import { Address } from './address';
import { ContactData } from './contact-data';
import { isNullOrUndefined } from "../utils";

/*
 * "ParticipantData" : {
 *   "required" : ["type", "name", "address", "contactData"],
 *   "type" : "object",
 *   "properties" : {
 *     "type" : {
 *       "description" : "Art",
 *       "enum" : ["TransportCode", "Other"],
 *       "type" : "string"
 *     },
 *     "name" : {
 *       "description" : "Name",
 *       "type" : "string"
 *     },
 *     "address" : {
 *       "$ref" : "#/definitions/Address",
 *       "description" : "Adresse"
 *     },
 *     "contactData" : {
 *       "$ref" : "#/definitions/ContactData",
 *       "description" : "Kontaktdaten"
 *     },
 *     "timeFrame" : {
 *       "description" : "Abhol-/Zustell-Zeitfenster (optional)",
 *       "type" : "string"
 *     },
 *     "additionalNotes" : {
 *       "description" : "Zusätzliche Bemerkungen (mehrzeilig)",
 *       "type" : "string"
 *     }
 *   }
 * },
 */

type ParticipantKind = 'Transport' | 'Other';

// eslint-disable-next-line no-underscore-dangle, id-blacklist, id-match
const ParticipantKind = {
  Transport: 'TransportCode',
  TransportCode: 'Transport',
  Other: 'Other',
};

export class Participant {
  constructor(
    public kind: ParticipantKind,
    public name: string,
    public address: Address,
    public contactData: ContactData,
    public timeFrame?: string,
    public additionalNotes?: string,
  ) { }

  public static fromJSON(json: {
    // eslint-disable-next-line
    type: string,
    name: string,
    address: any,
    contactData: any,
    timeFrame?: string,
    additionalNotes?: string,
  }): Participant {
    if (!json) {
      throw new Error('Participant JSON should not be undefined');
    }
    if (!json.type) {
      throw new Error('Participant JSON should have property: type');
    }
    if (isNullOrUndefined(json.name)) {
      throw new Error('Participant JSON should have property: name');
    }
    if (!json.address) {
      throw new Error('Participant JSON should have property: address');
    }
    if (!json.contactData) {
      throw new Error('Participant JSON should have property: contactData');
    }

    return new Participant(
      ParticipantKind[json.type],
      json.name,
      Address.fromJSON(json.address),
      ContactData.fromJSON(json.contactData),
      json.timeFrame,
      json.additionalNotes,
    );
  }
}
